module.exports = __webpack_public_path__ + "4be8cfe6e2f94972d9068d1a48ac1666.svg";